import { onError } from "@apollo/client/link/error";
import { handleTokenExpiration, isGraphQLErrorWithCode } from "@utils";

const TIMEOUT = 5000;

let isHandlingTokenExpiration = false;

export const errorLink = onError((error) => {
  if (isGraphQLErrorWithCode(error, "GE0002")) {
    if (!isHandlingTokenExpiration) {
      isHandlingTokenExpiration = true;
      handleTokenExpiration();
    }

    /**
     * Add a timeout so that we don't execute the handling
     * of token expiration multiple times
     */
    setTimeout(() => {
      isHandlingTokenExpiration = false;
    }, TIMEOUT);
  }
});
